import React, { useEffect, useState } from "react";
import "./styles.scss";
import { FormHeader, CategoryCard } from "../../components";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { CreateNewTags } from "../CreateNewItem";
import { getLanguage } from "../../utils/environment";
import Scrollbars from "react-custom-scrollbars-2";
import { useDispatch, useSelector } from "react-redux";
import { setTagsList, setSelectTag } from "./redux/actions";
import { deleteTag, getAllTags } from "./service/tags.service";
import { Store } from "react-notifications-component";

const lan = getLanguage();

const Tags = () => {
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [newsList, setNewsList] = useState([]);
  const [tagList, setTagList] = useState([]);
  const [selectedNews, setSelectNews] = useState([]);
  const [selectTagId, setSelectTagId] = useState("");
  const dispatch = useDispatch();
  const tagsList = useSelector((state) => state.tagsReducer.tagsList);

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  const onClickRefresh = async () => {
    setIsLoading(true);
    await fetchData();
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const getList = await getAllTags();
      console.log("Get All Tags : ", getList);

      if (getList?.data) {
        dispatch(setTagsList(getList.data));
      } else {
        console.log("Data Not Found");
      }
    } catch (error) {
      console.log("Error fetching Data", error);
    }
  };

  // const updateForm = { ...formData };

  return (
    <>
      <div className="hne-tags-wrapper">
        <div className="col-9 tags-body-wrapper">
          <FormHeader
            data={{
              formHeader: "Tags",
              size: "md-md",
            }}
          />
          <div className="hne-sub-header-wrapper">
            {/* <div className="hne-sub-header-wrapper"> */}
            <div className="shw-id">Id</div>
            <div className="shw-si"> </div>
            <div className="shw-si">Tag Name</div>
          </div>
          {/* </div> */}
          <div className="hne-body-wrapper">
            <Scrollbars
              onScroll={handleOnScroll}
              renderView={(props) => (
                <div
                  {...props}
                  style={{ ...props.style, overflowX: "hidden" }}
                />
              )}
              style={{ height: viewPointHeight - 300 }}
            >
              {Array.isArray(tagsList) && tagsList.length > 0 ? (
                tagsList.map((tag) => (
                  <CategoryCard
                    isSelect={selectTagId === tag?.tag_id}
                    id={tag?.tag_id}
                    nameEN={tag?.tag_name}
                    edit="Edit"
                    onClick={() => {
                      setSelectTagId(tag?.tag_id);
                      dispatch(setSelectTag(tag));
                    }}
                    delete="Delete"
                    onClickRemove={async () => {
                      setIsLoading(true);
                      try {
                        let result = await deleteTag(tag?.tag_id);
                        console.log("Delete Tags Result: ", result);
                        if (result?.data) {
                          Store.addNotification({
                            title: "Success",
                            message: "Tags successfully deleted",
                            type: "success",
                            container: "top-right",
                            dismiss: {
                              duration: 2000,
                              onScreen: true,
                            },
                          });
                        }
                        await onClickRefresh();
                      } catch (error) {
                        console.log("Error deleting Tags", error);
                        Store.addNotification({
                          title: "Error",
                          message: "Failed to delete Tags",
                          type: "danger",
                          container: "top-right",
                          dismiss: {
                            duration: 2000,
                            onScreen: true,
                          },
                        });
                      }
                    }}
                  />
                ))
              ) : (
                <div className="error-message">No Tags Found</div>
              )}
            </Scrollbars>
          </div>
        </div>

        {/*right side*/}
        <div className="col-3 Tags-right-side-wrapper">
          <CreateNewTags refresh={onClickRefresh} />
        </div>
      </div>
    </>
  );
};
export default withRouter(Tags);
